export interface ICompactionTestNeighborhood {
  territoryName: string;
  neighborhoodName: string;
  neighborhoodId: number;
}

export interface ICompactionTestJob {
  jobId: number;
  hasCurrentFile: boolean;
  currentValidationDate: string;
  lotNumber: number;
}

export interface ICompactionTestFile {
  id: number;
  fileName: string;
  uploadedAt: string;
  uploadedBy: string;
  expirationDate: string;
}

export interface ICompactionTestDetail {
  jobId: number;
  hasCurrentFile: boolean;
  currentExpirationDate: string;
  lotNumber: number;
}

export interface ICompactionTestUploadPayload {
  compactionLetterFile: File;
  expiration: string;
}

export enum CompactionTestLetterType {
  CompactionTestLetterOne = 'CompactionTestLetterOne',
  CompactionTestLetterTwo = 'CompactionTestLetterTwo'
}
